
import { createAction, props } from '@ngrx/store';

export const switchRegion = createAction('Switching region', props<{ country: string }>());


export const swtichTab = createAction('Switching tabs', props<{tab: string}>())